// extracted by mini-css-extract-plugin
export var cardLayout = "_6d-1";
export var paginationContainer = "_6d-0";